/**
 * We use a square to position our points with the following values
 *       (N)
 * (NW)7  0  1(NE)
 *  (W)6     2(E)
 * (SW)5  4  3(SE)
 *       (S)
 */
const getDirection = index => {
  const position = index % 8;
  const offset = Math.floor(index / 8) + 1;

  return { position, offset };
};
/**
 * Since we're not at the poles, we can use the dirty estimate that:
 * - 111,111 meters (111.111 km) in the y direction is 1 degree (of latitude)
 * - 111,111 * cos(latitude) meters in the x direction is 1 degree (of longitude)
 */
const generateClosePoint = (point, position, offset = 1) => {
  const direction = position >= 4 ? -1 : 1;
  const distance = 5 * offset * direction;

  const verticalSpace = distance / 111111;
  const latitudeRadians = (point.Latitude * Math.PI) / 180;
  const horizontalSpace = distance / (111111 * Math.cos(latitudeRadians));

  if (position === 0 || position === 4) {
    return {
      ...point,
      Latitude: point.Latitude + verticalSpace,
    };
  }

  if (position === 1 || position === 5) {
    return {
      Latitude: point.Latitude + verticalSpace,
      Longitude: point.Longitude + horizontalSpace,
    };
  }

  if (position === 2 || position === 6) {
    return {
      ...point,
      Longitude: point.Longitude + horizontalSpace,
    };
  }

  return {
    Latitude: point.Latitude - verticalSpace,
    Longitude: point.Longitude + horizontalSpace,
  };
};

const processLocation = (location, group, index) => {
  if (group.length === 1) {
    return {
      ...location,
      PinClusterCount: 1,
      PinClusterIndex: 0,
    };
  }

  const { position, offset } = getDirection(index);

  return {
    ...location,
    ...generateClosePoint(location, position, offset),
    PinClusterCount: group.length,
    PinClusterIndex: index,
  };
};

const getLocationKey = ({ Latitude, Longitude }) => `${Latitude}|${Longitude}`;

/**
 * with this function we group the original array by coordinates,
 * each pair of lat/long is represented by an array and contains all the points
 * with the same coordinates
 */
const groupLocations = dataArray =>
  dataArray?.reduce((acc, current) => {
    const locationKey = getLocationKey(current);
    const currentGroup = acc.get(locationKey) || [];

    acc.set(locationKey, [...currentGroup, current]);

    return acc;
  }, new Map());

const normaliseRecommendations = data => {
  const groupedLocations = groupLocations(data);
  const nextGroupIndexes = new Map();

  return data?.map(location => {
    const locationKey = getLocationKey(location);
    const group = groupedLocations?.get(locationKey) || [];
    const index = nextGroupIndexes.get(locationKey) || 0;

    nextGroupIndexes.set(locationKey, index + 1);

    return processLocation(location, group, index);
  });
};

export default normaliseRecommendations;
